import type { NavLink } from '#core/types'

const BASE = '/market-maker-leaderboard'

export const leaderboardMainNavItems: NavLink[] = [
  { label: 'Performance Index', to: BASE, icon: 'i-heroicons-square-3-stack-3d' },
  { label: 'Depth', to: `${BASE}/depth`, icon: 'i-heroicons-chart-bar' },
  { label: 'Volume', to: `${BASE}/volume`, icon: 'i-heroicons-presentation-chart-line' },
  { label: 'Spread', to: `${BASE}/spread`, icon: 'i-heroicons-arrows-right-left' },
  { label: 'KPI Adherence', to: `${BASE}/kpi`, icon: 'i-heroicons-flag' },
]

export const leaderboardDocsNavItems: NavLink[] = [
  { label: 'Documentation', to: `${BASE}/documentation`, icon: 'i-heroicons-document-text', isStrict: false },
]

export const leaderboardNavItems: NavLink[] = [
  ...leaderboardMainNavItems,
  ...leaderboardDocsNavItems,
]
